module.exports = __webpack_public_path__ + "media/images/admin/dropzone/trash-473f25b3d39871ff3d5d64698e9a0e87.svg";